import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'react-toolbox';
import { normalizeImages, readAndEncodeImages } from '../../../../../../../../../utils/imageUpload';

class ProductTemplate extends React.Component {
  handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    if (this.props.onReadStart) this.props.onReadStart();

    readAndEncodeImages(files).then((newImages) => {
      const images = normalizeImages(this.props.product_template);
      this.props.onChange([...images, ...newImages]);
      if (this.props.onReadEnd) this.props.onReadEnd();
    });

    if (this.fileInput) {
      this.fileInput.value = '';
    }
  };

  removeImage = (index) => {
    const images = normalizeImages(this.props.product_template);
    this.props.onChange(images.filter((_, i) => i !== index));
  };

  render() {
    const images = normalizeImages(this.props.product_template);

    return (
      <div style={{ marginTop: '20px' }}>
        <h5>Product Template</h5>
        <h6>
          This section should be utilized if needed for highly configurable products, complex
          measurements, or specification of products.
        </h6>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={this.handleFileChange}
          style={{ marginTop: '8px' }}
          ref={(input) => { this.fileInput = input; }}
        />
        {images.map((image, index) => (
          <div key={image.id || image.image_data_url} style={{ marginTop: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '8px' }}>{image.file_name || 'Image attached'}</span>
              <IconButton
                icon="close"
                onClick={() => this.removeImage(index)}
              />
            </div>
            <img
              src={image.image_data_url}
              alt="Product Template preview"
              style={{ maxWidth: '200px', maxHeight: '200px', marginTop: '4px' }}
            />
          </div>
        ))}
      </div>
    );
  }
}

ProductTemplate.propTypes = {
  product_template: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  onReadStart: PropTypes.func,
  onReadEnd: PropTypes.func,
};

export default ProductTemplate;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/ProductTemplate.jsx